export const QuestionTypes = Object.freeze({
  MULTIPLE_CHOICE_SINGLE_ANSWER: "MultipleChoiceSingleAnswer",
  MULTIPLE_CHOICE_MULTIPLE_ANSWER: "MultipleChoiceMultipleAnswer",
  TRUE_FALSE: "TrueFalse",
  YES_NO: "YesNo",
  NOTE_COMPLETION_ONE_WORD: "NoteCompletionOneWord",
  SUMMARY_COMPLETION_TWO_WORDS: "SummaryCompletionTwoWords",
  SENTENCE_COMPLETION_ONE_WORD: "SentenceCompletionOneWord",
  MATCHING_HEADINGS: "MatchingHeadings",
  MATCHING_INFORMATION: "MatchingInformation",
  MATCHING_FEATURES: "MatchingFeatures",
  MATCHING_ENDINGS: "MatchingEndings",
});
